import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ children, to, variant = 'primary', size = 'md', className = '', ...props }) => {
  const baseStyle = "inline-flex items-center justify-center font-medium transition-all duration-300 ease-out rounded-none";
  
  const sizes = {
    sm: "px-5 py-2.5 text-sm",
    md: "px-8 py-4 text-sm tracking-wide",
    lg: "px-10 py-5 text-base tracking-wide"
  };

  const variants = {
    primary: "bg-epoq-blue text-epoq-white hover:bg-epoq-lime hover:text-epoq-blue",
    secondary: "bg-epoq-lime text-epoq-blue hover:bg-epoq-blue hover:text-epoq-white",
    outline: "border border-epoq-blue text-epoq-blue hover:bg-epoq-blue hover:text-epoq-white",
    ghost: "text-epoq-blue hover:opacity-60 underline decoration-1 underline-offset-4"
  };

  const combinedClassName = `${baseStyle} ${sizes[size]} ${variants[variant]} ${className}`;

  if (to) {
    return (
      <Link to={to} className={combinedClassName} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <button className={combinedClassName} {...props}>
      {children}
    </button>
  );
};

export default Button;